import { SettingsApi } from '@src/shared/api';
import { ApiError, SETTINGS_KEYS } from '@src/shared/models';
import { convertSettingsResponse } from '@src/shared/utils/settings';
import { useAppStore } from '@src/shared/zustand/store';
import { SettingsState } from './settings.types';

export const setIdwallPoolingIntervals = (value: number[]) =>
  useAppStore.setState({ idwallPoolingIntervals: value });

export const setPaymentPoolingIntervals = (value: number[]) =>
  useAppStore.setState({ paymentPoolingIntervals: value });

export const setEmailValidationInterval = (value: number) =>
  useAppStore.setState({ emailValidationInterval: value });

export const getSettings = async (
  callback: (error: ApiError | null, state: SettingsState | null) => void
) => {
  try {
    const data = await SettingsApi.getSettings(SETTINGS_KEYS);

    const {
      paymentPoolingIntervals,
      emailValidationInterval,
      idwallPoolingIntervals,
    } = convertSettingsResponse(data.all);

    setPaymentPoolingIntervals(paymentPoolingIntervals);
    setEmailValidationInterval(emailValidationInterval);
    setIdwallPoolingIntervals(idwallPoolingIntervals);

    callback(null, {
      paymentPoolingIntervals,
      emailValidationInterval,
      idwallPoolingIntervals,
    });
  } catch (error) {
    callback(error, null);
  }
};
